import { TextSize, Weight } from 'components/typography/text'

import styled from 'styled-components'
import { Image } from 'components'
import { CoinWrapperProps } from './single/types'
import { GLOBAL_COLORS } from 'theme'

import { Text } from 'components'
import { css } from 'styled-components'
import { PriceImpactState } from '../transactional-context/interface'

/**
 * Wraps the token received component
 */
export const TokenReceivedWrapper = styled.div<{ priceImpactWarning: PriceImpactState }>`
  padding-bottom: 15px;
  display: flex;
  flex-flow: column;
  ${({ priceImpactWarning }) => {
    if (priceImpactWarning === PriceImpactState.WARN) {
      return css`
        margin: 10px 20px 0px 20px;
      `
    } else {
      return css`
        border-bottom: 1px solid ${({ theme }) => theme.borderColor};
        margin: 10px 20px 15px 20px;
      `
    }
  }}
`

/**
 * Wraps the tokens received output field
 */
export const TokensReceivedTextWrapper = styled.div<{ isTooltip: boolean }>`
  color: ${({ theme, isTooltip }) => {
    if (isTooltip) {
      return GLOBAL_COLORS.seashellWhite
    } else {
      return theme.seashellWhiteToDeepOceanBlue
    }
  }};
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  opacity: ${({ theme, isTooltip }) => (isTooltip ? '1' : theme.darkMode ? '0.4' : '0.6')};
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 8px;
`

/**
 * Styles the header field
 */
export const Header = styled.div`
  font-size: ${TextSize.four};
  font-weight: ${Weight.SemiBold};
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
`

export const TransactableCoinsWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`

export const WrapperCoin = styled.div<CoinWrapperProps>`
  display: flex;
  margin-right: 2px;
  ${(props) =>
    props.labelIcon &&
    props.iconCompress &&
    `&::after {
            content: "+${props.labelIcon}";
            display: flex;
            justify-content: center;
            align-items: center;
            height: 25px;
            margin: 3px 3px 3px -2px;
            font-size: 12px;
            width: 25px;
            color: ${GLOBAL_COLORS.white};
            background: ${GLOBAL_COLORS.deepOceanBlue};
            border-radius: 50%;
          }
          & div:not(:first-child) {
            margin-left: -20px;
          }
          `}
`

export const Coin = styled(Image)`
  background-size: cover;
  height: 32px;
  width: 32px;
  border-radius: 50%;
`

export const TooltipValue = styled(Text)`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  color: ${GLOBAL_COLORS.seashellWhite};
`

export const CoinValue = styled(Text)`
  font-size: ${TextSize.p};
  font-weight: ${Weight.SemiBold};
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
`

/**
 * a styled wrapper around dollar and price of coin
 */
export const CoinDataOutputWrapper = styled.div`
  display: flex;
  flex-flow: column;
  padding-left: 8px;
`
